/// <reference path='../_all.ts' />

module navigation {
  export interface IPageMetaService {
    getPageMeta(key? : string): IPhotometerGlobalVar | string | any;
    getContentFilterFor(key : string, useRouteParameter?: boolean, category?: number) : editor.EditorFilter;
    searchRouteParameter(placeholder : string) : IRouteParameter;
    searchPage(placeholder : string, id: number) : angular.IPromise<MenuNode>;
  }

  export const HL: string = "hl";
  export const HLFULL: string = "hlFull";
  export const HLPREFIX: string = "hlPrefix";
  export const CURRENT: string = "current";
  export const PARENT: string = "parent";
  export const USERNAME: string = "username";
  export const PAGEID: string = "PageId";

  export interface IPageMetaServiceFunction {
    (key? : string): IPhotometerGlobalVar | string | any;
  }

}